import React from 'react'
import {
  ShoppingBag,
  Video,
  Image,
  Film,
  Box,
  PieChart,
  Gpu,
  Cable,
  Wand,
  Wand2,
  Sparkles,
} from 'lucide-react'
import { useAuthHeader } from '../../../hooks/header/useAuthHeader'
import { useNavigation } from '../../../hooks/header/useNavigation'
import { useHeaderState } from '../../../hooks/header/useHeaderState'
import { FreeButton } from '../../atom/FreeButton'
import { ReactComponent as StyleShotIcon } from 'svg/vector-icon.svg'
import {
  LEFT_NAV,
  RIGHT_NAV,
  LANGUAGE_MENU,
} from '../../../constants/navigation'
import HeaderAIStudioTab from './HeaderAIStudioTab'
import HeaderUserMenu from './HeaderUserMenu'
import { useGetMyPoint } from 'hooks/query/point/useGetMyPoint'

const HeaderDesktop: React.FC = () => {
  const { userData, isLoggedIn, currentPath } = useAuthHeader()
  const { data: myPointData, refetch: getMyPointRefetch } = useGetMyPoint()
  const { moveToPageByPath } = useNavigation()
  const { headerState, setState } = useHeaderState()

  const handleUserMenuToggle = (isOpen: boolean) => {
    setState('isUserMenuOpen', isOpen)
  }

  const handleAIStudioToggle = (isOpen: boolean) => {
    setState('isAIStudioOpen', isOpen)
  }

  const handlePriceGuideToggle = (isOpen: boolean) => {
    setState('isPriceGuideOpen', isOpen)
  }

  const handleMyVideosToggle = (isOpen: boolean) => {
    setState('isMyVideosOpen', isOpen)
  }

  const handleContentVideoToggle = (isOpen: boolean) => {
    setState('isContentVideoOpen', isOpen)
  }

  const handleGenieToggle = (isOpen: boolean) => {
    setState('isGenieOpen', isOpen)
  }

  const renderLeftNavigation = () => {
    return (
      <div className="flex items-center gap-2">
        {LEFT_NAV.map((item) => {
          // if (item.path === 'ai-studio') {
          //   return (
          //     <HeaderAIStudioTab
          //       key={item.path}
          //       isOpen={headerState.isAIStudioOpen}
          //       onMouseEnter={() => handleAIStudioToggle(true)}
          //       onMouseLeave={() => handleAIStudioToggle(false)}
          //       className="mx-1"
          //     />
          //   )
          // }

          // 로그인이 필요한 메뉴 체크
          if (item.user && !isLoggedIn) {
            return null
          }

          // 생성 내역 버튼은 드롭다운으로 처리
          if (item.path === 'my-videos') {
            const isActive =
              currentPath.includes(item.path) || currentPath.includes('gallery')

            return (
              <div
                key={item.path}
                className="relative"
                onMouseEnter={() => handleMyVideosToggle(true)}
                onMouseLeave={() => handleMyVideosToggle(false)}
              >
                <button
                  className={`rounded-[20px] px-4 py-2 font-bold transition-colors ${
                    isActive
                      ? 'bg-main text-white'
                      : 'text-[#2E343D] hover:bg-[#F6F8FB] hover:text-[#768296]'
                  }`}
                >
                  <span className="text-[14px]">{item.name}</span>
                </button>

                {/* 생성 내역 드롭다운 */}
                {headerState.isMyVideosOpen && (
                  <div className="absolute left-0 top-full z-50 w-[184px] rounded-[10px] border border-[#D9DEE8] bg-white py-3 shadow-[0px_4px_10px_0px_rgba(0,0,0,0.1)]">
                    <div className="flex flex-col">
                      {/* 상품 영상 생성내역 */}
                      <button
                        className="flex w-full items-center gap-2 p-4 text-left transition-colors hover:bg-[#F6F8FB]"
                        onClick={() => {
                          moveToPageByPath('my-videos?type=plv')
                          handleMyVideosToggle(false)
                        }}
                      >
                        <div className="flex h-4 w-4 items-center justify-center">
                          <ShoppingBag
                            size={16}
                            className="stroke-[#2E343D] stroke-[2px]"
                          />
                        </div>
                        <span className="text-[14px] font-medium text-[#2E343D]">
                          상품 영상
                        </span>
                      </button>
                      <button
                        className="flex w-full items-center gap-2 p-4 text-left transition-colors hover:bg-[#F6F8FB]"
                        onClick={() => {
                          moveToPageByPath('gallery')
                          handleMyVideosToggle(false)
                        }}
                      >
                        <div className="flex h-4 w-4 items-center justify-center">
                          <StyleShotIcon />
                        </div>
                        <span className="text-[14px] font-medium text-[#2E343D]">
                          스타일룸
                        </span>
                      </button>
                      {/* 컨텐츠 영상 생성내역 */}
                      <button
                        className="flex w-full items-center gap-2 p-4 text-left transition-colors hover:bg-[#F6F8FB]"
                        onClick={() => {
                          moveToPageByPath('my-videos?type=lcv')
                          handleMyVideosToggle(false)
                        }}
                      >
                        <div className="flex h-4 w-4 items-center justify-center">
                          <Film
                            size={16}
                            className="stroke-[2 px] stroke-[#2E343D]"
                          />
                        </div>
                        <span className="text-[14px] font-medium text-[#2E343D]">
                          컨텐츠 영상
                        </span>
                      </button>
                      {/* AI 영상 생성내역 */}
                    </div>
                  </div>
                )}
              </div>
            )
          }

          if (item.path.includes('short-video-editor')) {
            const isActive = currentPath.includes(item.path)
            return (
              <>
                <div
                  key={item.path}
                  className="relative"
                  onMouseOver={() => handleContentVideoToggle(true)}
                  onMouseLeave={() => handleContentVideoToggle(false)}
                >
                  <button
                    className={`rounded-[20px] px-4 py-2 font-bold transition-colors ${
                      isActive
                        ? 'bg-main text-white'
                        : 'text-[#2E343D] hover:bg-[#F6F8FB] hover:text-[#768296]'
                    }`}
                    onClick={() => {
                      moveToPageByPath('short-video-editor?createType=link')
                    }}
                  >
                    <span className="text-[14px]">{item.name}</span>
                  </button>
                  {headerState.isContentVideoOpen && (
                    <div className="absolute left-0 top-full z-50 min-w-[220px] rounded-[10px] border border-[#D9DEE8] bg-white py-3 shadow-[0px_4px_10px_0px_rgba(0,0,0,0.1)]">
                      <div className="flex flex-col">
                        {/* 상품 영상 생성내역 */}
                        <button
                          className="flex w-full items-center gap-2 p-4 text-left transition-colors hover:bg-[#F6F8FB]"
                          onClick={() => {
                            moveToPageByPath(
                              'short-video-editor?createType=link',
                            )
                            handleContentVideoToggle(false)
                          }}
                        >
                          <span className="text-[14px] font-medium text-[#2E343D]">
                            링크로 만들기
                          </span>
                        </button>
                      </div>
                      <div className="flex flex-col">
                        {/* 상품 영상 생성내역 */}
                        <button
                          className="flex w-full items-center gap-2 p-4 text-left transition-colors hover:bg-[#F6F8FB]"
                          onClick={() => {
                            moveToPageByPath(
                              'short-video-editor?createType=text',
                            )
                            handleContentVideoToggle(false)
                          }}
                        >
                          <span className="text-[14px] font-medium text-[#2E343D]">
                            텍스트로 만들기 - 다국어 지원 🌏
                          </span>
                        </button>
                      </div>
                    </div>
                  )}
                </div>
              </>
            )
          }

          if (item.path.includes('ai/create')) {
            const isActive = currentPath.includes(item.path)
            return (
              <>
                <div
                  key={item.path}
                  className="relative"
                  onMouseOver={() => handleGenieToggle(true)}
                  onMouseLeave={() => handleGenieToggle(false)}
                >
                  <button
                    className={`rounded-[20px] px-4 py-2 font-bold transition-colors ${
                      isActive
                        ? 'bg-main text-white'
                        : 'text-[#2E343D] hover:bg-[#F6F8FB] hover:text-[#768296]'
                    }`}
                  >
                    <span className="text-[14px]">{item.name}</span>
                  </button>
                  {headerState.isGenieOpen && (
                    <div className="absolute left-0 top-full z-50 min-w-[220px] rounded-[10px] border border-[#D9DEE8] bg-white py-3 shadow-[0px_4px_10px_0px_rgba(0,0,0,0.1)]">
                      <div className="flex flex-col">
                        {/* 생성형 이미지  */}
                        <button
                          className="flex w-full items-center gap-2 p-4 text-left transition-colors hover:bg-[#F6F8FB]"
                          onClick={() => {
                            moveToPageByPath('create/image')
                            handleGenieToggle(false)
                          }}
                        >
                          <Wand2 className="text-main" />
                          <span className="text-[14px] font-bold text-[#2E343D]">
                            이미지
                          </span>
                        </button>
                      </div>
                      <div className="flex flex-col">
                        {/* 상품 영상 생성내역 */}
                        <button
                          className="flex w-full items-center gap-2 p-4 text-left transition-colors hover:bg-[#F6F8FB]"
                          onClick={() => {
                            moveToPageByPath('create/video')
                            handleGenieToggle(false)
                          }}
                        >
                          <Sparkles className="text-main" />
                          <span className="t text-[14px] font-bold text-[#2E343D]">
                            비디오
                          </span>
                        </button>
                      </div>
                    </div>
                  )}
                </div>
              </>
            )
          }

          const isActive = (() => {
            if (item.path === 'home') return false

            // 정확한 경로 매칭을 위해 슬래시로 구분된 세그먼트 비교
            const currentSegments = currentPath.split('/').filter(Boolean)
            const itemSegments = item.path.split('/').filter(Boolean)

            // video-editor와 short-video-editor 구분
            if (item.path === 'video-editor') {
              return (
                currentSegments[0] === 'video-editor' &&
                !currentPath.includes('short-video-editor')
              )
            }

            if (item.path === 'short-video-editor') {
              return currentSegments[0] === 'short-video-editor'
            }

            if (item.path === 'ai-studio') {
              return (
                currentSegments[0] === 'ai-studio' &&
                currentSegments[1] !== 'gallery'
              )
            }

            // 다른 경로들은 기본 로직 사용
            return currentPath.includes(item.path)
          })()

          return (
            <button
              key={item.path}
              className={`rounded-[20px] px-4 py-2 font-bold transition-colors ${
                isActive
                  ? 'bg-main text-white'
                  : 'text-[#2E343D] hover:bg-[#F6F8FB] hover:text-[#768296]'
              }`}
              onClick={() => moveToPageByPath(item.path)}
            >
              <span className="text-[14px]">{item.name}</span>
              {item.event && (
                <span className="ml-2 rounded bg-[#FF6B6B] px-1.5 py-0.5 text-[10px] text-white">
                  NEW
                </span>
              )}
            </button>
          )
        })}
      </div>
    )
  }

  const renderRightNavigation = () => {
    return (
      <div className="flex items-center gap-2">
        {RIGHT_NAV.map((item) => {
          const isActive = (() => {
            if (item.path === 'home') return false

            // 정확한 경로 매칭을 위해 슬래시로 구분된 세그먼트 비교
            const currentSegments = currentPath.split('/').filter(Boolean)
            const itemSegments = item.path.split('/').filter(Boolean)

            // video-editor와 short-video-editor 구분
            if (item.path === 'video-editor') {
              return (
                currentSegments[0] === 'video-editor' &&
                !currentPath.includes('short-video-editor')
              )
            }

            if (item.path === 'short-video-editor') {
              return currentSegments[0] === 'short-video-editor'
            }

            // 다른 경로들은 기본 로직 사용
            return currentPath.includes(item.path)
          })()

          // 가격 안내 버튼은 드롭다운으로 처리
          if (item.path === 'price-guide') {
            return (
              <div
                key={item.path}
                className="relative"
                onMouseEnter={() => handlePriceGuideToggle(true)}
                onMouseLeave={() => handlePriceGuideToggle(false)}
              >
                <button
                  className={`rounded-[20px] px-4 py-2 font-bold transition-colors ${
                    isActive
                      ? 'bg-main text-white'
                      : 'text-[#2E343D] hover:bg-[#F6F8FB] hover:text-[#768296]'
                  }`}
                  onClick={() => moveToPageByPath(item.path)}
                >
                  <span className="text-[14px]">{item.name}</span>
                </button>

                {/* 가격 안내 드롭다운 */}
                {headerState.isPriceGuideOpen && (
                  <div className="absolute right-0 top-full z-50 w-[184px] rounded-[10px] border border-[#D9DEE8] bg-white py-3 shadow-[0px_4px_10px_0px_rgba(0,0,0,0.1)]">
                    <div className="flex flex-col">
                      {/* 플랜 가격 */}
                      <button
                        className="flex w-full items-center gap-2 p-4 text-left transition-colors first:rounded-t-[10px] last:rounded-b-[10px] hover:bg-[#F6F8FB]"
                        onClick={() => moveToPageByPath('price-guide')}
                      >
                        <div className="flex h-4 w-4 items-center justify-center">
                          <ShoppingBag
                            size={16}
                            className="stroke-[#2E343D] stroke-[2px]"
                          />
                        </div>
                        <span className="text-[14px] font-medium text-[#2E343D]">
                          상품 영상 플랜 가격
                        </span>
                      </button>
                      {/* 스타일룸 가격 */}
                      <button
                        className="flex w-full items-center gap-2 p-4 text-left transition-colors first:rounded-t-[10px] last:rounded-b-[10px] hover:bg-[#F6F8FB]"
                        onClick={() =>
                          moveToPageByPath('styleRoom-price-guide')
                        }
                      >
                        <div className="flex h-4 w-4 items-center justify-center">
                          <StyleShotIcon className="" />
                        </div>
                        <span className="text-[14px] font-medium text-[#2E343D]">
                          스타일룸 가격
                        </span>
                      </button>
                      {/* 크레딧 가격 */}
                      <button
                        className="flex w-full items-center gap-2 p-4 text-left transition-colors first:rounded-t-[10px] last:rounded-b-[10px] hover:bg-[#F6F8FB]"
                        onClick={() =>
                          moveToPageByPath('shortform-price-guide')
                        }
                      >
                        <div className="flex h-4 w-4 items-center justify-center">
                          <Film
                            size={16}
                            className="stroke-[#2E343D] stroke-[2px]"
                          />
                        </div>
                        <span className="text-[14px] font-medium text-[#2E343D]">
                          컨텐츠 영상 가격
                        </span>
                      </button>
                    </div>
                  </div>
                )}
              </div>
            )
          }

          return (
            <button
              key={item.path}
              className={`rounded-[20px] px-4 py-2 font-bold transition-colors ${
                isActive
                  ? 'bg-main text-white'
                  : 'text-[#2E343D] hover:bg-[#F6F8FB] hover:text-[#768296]'
              }`}
              onClick={() => moveToPageByPath(item.path)}
            >
              <span className="text-[14px]">{item.name}</span>
              {item.event && (
                <span className="ml-2 rounded bg-[#FF6B6B] px-1.5 py-0.5 text-[10px] text-white">
                  NEW
                </span>
              )}
            </button>
          )
        })}

        {/* 언어 선택 - 일단 주석처리 */}
        {/* <button className="font-bold py-2 px-4 rounded-[20px] text-[#2E343D] hover:text-[#768296] hover:bg-[#F6F8FB] transition-colors flex items-center gap-1">
          <span className="text-[14px]">{LANGUAGE_MENU.name}</span>
          <img
            src="/assets/img/icon_arrow2.png"
            alt="arrow"
            className="w-[10px] h-[6px]"
          />
        </button> */}

        {userData?.userInfo && (
          <div className="flex items-center gap-1 font-bold">
            <p className="text-[14px]">내 캐시</p>

            <p className="flex items-center gap-[2px] text-[14px] text-main">
              <img
                src="/assets/img/cash.png"
                alt="check_circle"
                className="h-[13px] w-[11px]"
              />
              {myPointData.totalPoint.toLocaleString()}
            </p>
          </div>
        )}
      </div>
    )
  }

  const renderUserSection = () => {
    if (isLoggedIn && userData?.userInfo) {
      const { name } = userData.userInfo

      return (
        <>
          <div
            className="relative flex cursor-pointer items-center gap-1 rounded-[20px] px-4 py-2 font-bold text-[#2E343D] transition-colors hover:bg-[#F6F8FB] hover:text-[#768296]"
            onMouseEnter={() => handleUserMenuToggle(true)}
          >
            <span className="text-[14px]">{`MY (${name})`}</span>
            <img
              src="/assets/img/icon_arrow2.png"
              alt="arrow"
              className={`h-[6px] w-[10px] transition-transform duration-300 ${
                headerState.isUserMenuOpen ? 'rotate-180' : ''
              }`}
            />
          </div>
          <HeaderUserMenu
            isOpen={headerState.isUserMenuOpen}
            onClose={() => handleUserMenuToggle(false)}
            userName={name}
            userType={userData.userType as any}
          />
        </>
      )
    }

    return (
      <div className="flex items-center gap-2">
        <button
          className="rounded-[20px] px-4 py-2 font-bold text-[#2E343D] transition-colors hover:bg-[#F6F8FB] hover:text-[#768296]"
          onClick={() => moveToPageByPath('sign-in')}
        >
          <span className="text-[14px]">로그인</span>
        </button>
        <FreeButton
          className="rounded-[20px] bg-href px-4 py-2 font-bold text-white transition-colors hover:bg-[#4A90E2]"
          onClick={() => moveToPageByPath('sign-up')}
        >
          <span className="text-[14px]">가입하고 무료체험</span>
        </FreeButton>
      </div>
    )
  }

  return (
    <div className="relative my-0 flex h-[80px] items-center justify-between px-3 md:h-[100px] md:px-6">
      {/* 로고 및 왼쪽 네비게이션 */}
      <div className="flex items-center gap-8">
        <button onClick={() => moveToPageByPath('home')}>
          <img
            className="w-[94px]"
            src="/assets/img/logo/fastcut_kr.png"
            alt="logo"
          />
        </button>

        {renderLeftNavigation()}
      </div>

      {/* 오른쪽 네비게이션 및 사용자 섹션 */}
      <div className="flex items-center gap-4">
        {renderRightNavigation()}
        {renderUserSection()}
      </div>
    </div>
  )
}

export default HeaderDesktop
